import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Form as BForm, Row, Spinner } from 'react-bootstrap';
import { mixed, object } from 'yup';

import { Button } from '../../Atoms/Button';
import Checkbox from '../../lib/Form/Checkbox';
import { FileUploader } from '../../Molecules/FileUploader';
import {
  fileTypes,
  requiredFileErrorMessage,
} from '../../Molecules/FileUploader/helper';

const allowedFileExtension = ['csv'];

const validationSchema = object().shape({
  uploadCsv: mixed()
    .required(requiredFileErrorMessage(allowedFileExtension))
    .test('format', requiredFileErrorMessage(allowedFileExtension), (value) => {
      if (!value) return false;
      return value[0] && fileTypes.csv.mime.includes(value[0].type);
    }),
});

export const UploadInternetUsers = ({ onFormSubmit, ...args }) => {
  return (
    <Formik
      initialValues={{
        uploadCsv: null,
        uploadType: 'add',
      }}
      validationSchema={validationSchema}
      onSubmit={(e) => {
        onFormSubmit(e);
      }}
    >
      {({ isValid, isSubmitting, dirty, handleSubmit, setFieldValue }) => {
        const submitDisabled = !!(!isValid || isSubmitting || !dirty);

        return (
          <Form onSubmit={handleSubmit}>
            <div>
              <FileUploader
                name="uploadCsv"
                {...args}
                onFileSelect={(file) => {
                  setFieldValue('uploadCsv', file);
                }}
              >
                <div className="col-md-4 col-lg-5 pt-3 pt-md-0">
                  <div>
                    <BForm.Label as={Row} className="ml-0 mb-2">
                      <strong>Upload Type: &nbsp; </strong>
                    </BForm.Label>
                    <BForm.Group className="mb-0">
                      <Checkbox
                        id="uploadTypeAdd"
                        type="radio"
                        value="add"
                        name="uploadType"
                        label={
                          <div>
                            Add -{' '}
                            <span className="font-weight-normal">
                              New Users
                            </span>
                          </div>
                        }
                      />

                      <Checkbox
                        id="uploadTypeUpdate"
                        type="radio"
                        value="update"
                        name="uploadType"
                        label={
                          <div>
                            Update -{' '}
                            <span className="font-weight-normal">
                              Add New/Edit Existing Users
                            </span>
                          </div>
                        }
                      />

                      <Checkbox
                        id="uploadTypeSync"
                        type="radio"
                        value="sync"
                        name="uploadType"
                        label={
                          <div>
                            Sync -{' '}
                            <span className="font-weight-normal">
                              Add New/Edit Existing/Delete Users
                            </span>
                          </div>
                        }
                      />
                    </BForm.Group>
                  </div>
                </div>
                <div className="col-md-3 text-center text-lg-right pt-2 pt-md-0">
                  <Button
                    type="submit"
                    variant={submitDisabled ? 'secondary' : 'primary'}
                    disabled={submitDisabled}
                    className="text-uppercase text-sm ml-2 btn-lg"
                  >
                    {isSubmitting && (
                      <Spinner animation="border" size="sm" className="mr-1" />
                    )}
                    UPLOAD FILE
                  </Button>
                </div>
              </FileUploader>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

UploadInternetUsers.propTypes = {
  onFormSubmit: PropTypes.func,
};

export default UploadInternetUsers;
